<template>
  <v-flex v-if="this.$appMng.isLoadingPage" class="fill-height">
    <v-container fluid class="fill-height">
      <v-row justify="center" align="center" class="ma-0">
        <loading-screen></loading-screen>
      </v-row>
    </v-container>
  </v-flex>
  <v-flex v-else class="fill-height">
    <v-app class="fill-height">
      <v-navigation-drawer v-model="drawer" temporary app stateless hide-overlay disable-resize-watcher
        disable-route-watcher :width="drawerWidth" id="mapview-navigation-drawer">
        <template v-slot:prepend>
          <v-toolbar color="#F1F3F4">
            <v-btn icon to="/app/processing-list">
              <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="mappa-logo">
                <path d="M13.184 12.2295L3.2334 22L16.2276 15.868L13.184 12.2295Z" fill="#C4C4C4" />
                <path d="M13.042 6.06334L0 0L16.2277 15.8686L13.042 6.06334Z" fill="#202020" />
                <path d="M19.2719 12.2295L29.2227 22L16.228 15.8683L19.2719 12.2295Z" fill="#C4C4C4" />
                <path d="M19.4138 6.06334L32.4561 0L16.2281 15.8686L19.4138 6.06334Z" fill="#202020" />
              </svg>
            </v-btn>
            <v-row align="center" justify="space-between" class="ma-0 px-4">
              <v-col cols="12" class="text-truncate">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span class="subtitle-1 processing-name" v-on="on">{{ processing["nm_processing"] }}</span>
                  </template>
                  <span>{{ processing["nm_processing"] }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <help-button v-if="false" :processing="processing" />

            <!-- <v-spacer/>
            <v-menu>
              <template v-slot:activator="{ on: menu }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        icon
                        color="white"
                        text
                        v-on="{ ...tooltip, ...menu }"
                    >
                      <v-icon>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <span>Páginas</span>
                </v-tooltip>
              </template>
              <v-list
                  nav
                  rounded
              >
                <v-list-item
                    v-for="item in menuList"
                    :key="item.name"
                    @click="item.onClick"
                    link
                >
                  <v-list-item-icon>
                    <v-icon
                        color="primary"
                    >
                      {{item.icon}}
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu> -->
          </v-toolbar>
          <v-row v-if="$vuetify.breakpoint.smAndDown" class="ma-0 my-2">
            <v-spacer />
            <v-btn tile color="primary" @click="drawer = !drawer">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-row>
        </template>
        <span style="display: none;">{{ processing["nm_processing"] }}</span>
        <main-panel-shared id="mapview-main-panel" />
        <!-- <template v-slot:append>
          <field-import/>
        </template> -->
      </v-navigation-drawer>
      <v-content>
        <v-flex style="height: 30px;" :class="['content-tools top full-width', {
          'active': drawer
        }]">
          <v-row align="start" style="height: 30px;" class="ma-0 processing-timeline__wrapper">
            <v-flex>
              <processings-timeline v-if="isProcessingTimelineActive" />
            </v-flex>
            <v-flex id="mapview-toolbox" style="height: 30px;" class="toolbox pa-2">
              <tool-box :processing="processing" v-show="map2DIsActive" />
            </v-flex>
          </v-row>
        </v-flex>
        <v-flex :class="['content-tools left full-height', {
          'active': drawer
        }]">
          <v-btn tile min-width="34px" max-width="34px" height="34px" absolute color="#00B3FF" @click="drawer = !drawer"
            class="btn-drawer__handler aero-close-btn">
            <v-icon v-if="drawer">
              mdi-chevron-left
            </v-icon>
            <v-icon v-else>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-flex class="pa-2 map__type bottom d-flex">
            <v-btn @click="onMap2DClick" tile small :color="map2DIsActive ? '#00B3FF' : ''"
              class="my-2 aero-map-type-change-btn aero-2d-btn">
              <span :class="map2DIsActive ? 'aero-active-btn' : ''">2D</span>
            </v-btn>
            <v-btn @click="onMap3DClick" tile small :color="map3DIsActive ? '#00B3FF' : ''"
              class="my-2 aero-map-type-change-btn aero-3d-btn">
              <span :class="map3DIsActive ? 'aero-active-btn' : ''">3D</span>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex class="content-tools bottom right">
          <v-row align="baseline" class="ma-0 processing-timeline__wrapper pa-2">
            <div id="floating-wrapper" ref="floating-wrapper" class="ma-1"></div>
            <div id="floating-wrapper-eval" ref="floating-wrapper-eval" class="ma-1"></div>
          </v-row>
        </v-flex>
        <v-container fluid class="fill-height pa-0">
          <v-row class="fill-height ma-0 content">
            <map2-d-shared v-show="map2DIsActive">
            </map2-d-shared>
            <!-- <map3-d
                v-show="map3DIsActive && !isOdm"
            >
            </map3-d> -->
            <map3-d-potree v-show="map3DIsActive && isOdm">
            </map3-d-potree>
          </v-row>
        </v-container>
      </v-content>
    </v-app>
  </v-flex>
</template>

<script>
import Map2DShared from "../components/MapView/Map2DShared"
// import Map2D from "../components/MapView/Map2D"
// import Map3D from "../components/MapView/Map3D"
import Map3DPotree from "../components/MapView/Map3DPotree"
import ToolBox from "../components/MapView/Utils/ToolBox"
import LoadingScreen from "../components/Helpers/LoadingScreen"
import { getProcessingShared, processingShare } from "../api/api-project"
import { FloatingCardsEventBus, MapViewEventBus } from "../helpers/mapview/events"
// import FieldImport from "../components/MapView/Geometries/Field/FieldImport"
import MainPanelShared from "../components/MapView/DrawerPanels/MainPanelShared"

// eslint-disable-next-line no-unused-vars
import "leaflet-draw"
import "leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.min"
import "../helpers/leaflet/leaflet-side-by-side"
import "leaflet-editable"
import "leaflet.path.drag"
import "leaflet.vectorgrid"
import "../helpers/leaflet/horus-leaflet"
import { mapActions } from "vuex"
import { CLEAN_MAPVIEW } from "../store/modules/mapview"
// import {filter} from "lodash/collection"
import ProcessingsTimeline from "../components/MapView/ProcessingsTimeline/ProcessingsTimeline"
import HelpButton from '../components/Helpers/Buttons/HelpButton'
// import { UserData } from '../api/api-auth'
// import { isEqual } from 'lodash/lang'

const _Map = Symbol.for("_Map")
const _Processing = Symbol.for("_Processing")
const SetMap = Symbol.for("SetMap")

export default {
  name: "MapViewShared",
  components: {
    HelpButton,
    ProcessingsTimeline,
    MainPanelShared,
    // FieldImport,
    LoadingScreen,
    // Map3D,
    Map3DPotree,
    // Map2D,
    Map2DShared,
    ToolBox
  },
  data: () => ({
    drawer: false,

    score: "0",
    comment: "",
    map: null,
    processing: null,
    processingList: [],
    map2DIsActive: true,
    map3DIsActive: false,

    currFloatingCard: null,
    currFloatingEvaluate: null,
  }),
  provide() {
    return {
      [_Map]: () => this.map,
      [_Processing]: () => this.processing,
      [SetMap]: this.setMap,
    }
  },
  methods: {
    setMap(value) {
      this.map = value
    },
    onCreated() {
      const { token } = this.$route.params
      console.log('>>> ', token)
      processingShare(token)
        .then((res) => {
          this.isSuccess = true
          let id = res.data.data.id_processing
          getProcessingShared(id)
            .then((res) => {
              const processing = res.data.data
              this.processing = Object.assign({}, this.processing, processing)
              this.processingList = Object.assign([], this.processingList, [processing])
              this.$appMng.setIsLoadingPage(false)
              console.log('>>> PROCESSING ::::: ', this.processing)
            })
        })
        .catch((err) => {
          console.log("1 >>> ", err)
          if (err.response)
            this.errorMessage = err.response.data.message

        })
        .finally(() => {
          this.isLoading = false
        })
      // const {id} = this.$route.params
      // const authToken = this.$apiAuth.getAuthToken()

      // getProcessingShared(authToken, id)
      //     .then((res) => {
      //       const processing = res.data.data
      //       this.processing = Object.assign({}, this.processing, processing)
      //       this.processingList = Object.assign([], this.processingList, [processing])
      //       this.$appMng.setIsLoadingPage(false)
      //       console.log('>>> PROCESSING ::::: ', this.processing)
      //     })
    },
    onMap2DClick() {
      if (this.map2DIsActive) return
      this.map2DIsActive = true
      this.map3DIsActive = false
    },
    onMap3DClick() {
      if (this.map3DIsActive) return
      this.map3DIsActive = true
      this.map2DIsActive = false
      MapViewEventBus.$emit("map-3d-open")
    },
    onFloatingEvaluateOpen(instance) {
      if (instance) {
        const ref = this.$refs["floating-wrapper-eval"]

        this.onFloatingEvaluateClose()

        instance.$refs["processing-evaluate-card"].onUpdateCard(this.score, this.comment, this.processing["id_processing"])
        this.currFloatingEvaluate = instance
        ref.appendChild(this.currFloatingEvaluate.$el)
      }
    },
    onFloatingEvaluateClose() {
      const ref = this.$refs["floating-wrapper-eval"]

      if (this.currFloatingEvaluate && ref) {
        if (ref.contains(this.currFloatingEvaluate.$el)) {
          ref.removeChild(this.currFloatingEvaluate.$el)
        }
      }
      this.currFloatingEvaluate = null
    },
    onFloatingCardOpen(instance) {
      const ref = this.$refs["floating-wrapper"]

      this.onFloatingCardClose()

      instance.layer.setViewStyle()
      this.currFloatingCard = instance
      ref.appendChild(this.currFloatingCard.$el)
    },
    onFloatingCardClose() {
      const ref = this.$refs["floating-wrapper"]

      if (this.currFloatingCard) {
        if (ref.contains(this.currFloatingCard.$el)) {
          if (this.currFloatingCard.$refs["field-edit-card"]) this.currFloatingCard.$refs["field-edit-card"].onCancelClick()
          this.currFloatingCard.layer.clearStyle()
          ref.removeChild(this.currFloatingCard.$el)
        }
      }
      this.currFloatingCard = null
    },
    callUpdateCard(score, comment) {
      this.score = score
      if (comment == "None") {
        comment = ""
      }
      this.comment = comment
      if (this.currFloatingEvaluate.$refs["processing-evaluate-card"]) {
        if (score == null || score == 0) {
          this.currFloatingEvaluate.$refs["processing-evaluate-card"].onUpdateCard(score, comment, this.processing["id_processing"], true)
        } else {
          this.currFloatingEvaluate.$refs["processing-evaluate-card"].onCloseClick()
        }
      }
    },
    requestProcessing(authToken, id_processing) {
      console.log(authToken, id_processing)
      this.onFloatingEvaluateClose()
      // getProcessingScore(authToken, id_processing)
      //     .then(res => {
      //       const processingResults = res.data.data
      //       if(processingResults) {
      //         const score = processingResults["user_evaluation"]
      //         const comment = processingResults["user_comment"]
      //         this.callUpdateCard(score, comment)
      //       }else{
      //         this.onFloatingEvaluateClose()
      //       }
      //     })
      //     .catch(() => {
      //       this.onFloatingEvaluateClose()
      //     })
    },
    // initConpass (userData, userPlan, isSubscriber, hasActivePlan) {
    //   setTimeout(() => {
    //     if (window.Conpass)
    //       window.Conpass.init({
    //         name: userData.strName,
    //         email: userData.strEmail,
    //         custom_fields: {
    //           plano: userPlan,
    //           plano_ativo: hasActivePlan,
    //           assinante: isSubscriber
    //         }
    //       })
    //     else if (this.conpassRetryCount < 100) this.initConpass(userData, userPlan, isSubscriber, hasActivePlan)
    //     else return
    //     this.conpassRetryCount += 1
    //   }, 1000)
    // },
    ...mapActions({
      cleanMapView: CLEAN_MAPVIEW
    })
  },
  created() {
    if (this.$vuetify.breakpoint.smAndUp) this.drawer = true

    this.onCreated()

    FloatingCardsEventBus.$on("open", this.onFloatingCardOpen)
    FloatingCardsEventBus.$on("close", this.onFloatingCardClose)
    FloatingCardsEventBus.$on("openEvaluate", this.onFloatingEvaluateOpen)
    FloatingCardsEventBus.$on("closeEvaluate", this.onFloatingEvaluateClose)
    FloatingCardsEventBus.$on("requestProcessing", this.requestProcessing)
  },
  computed: {
    drawerWidth() {
      if (this.$vuetify.breakpoint.mdAndUp) return 350
      return "100%"
    },
    // menuList() {
    //   if (this.$vuetify.breakpoint.smAndUp)
    //     return MenuList

    //   return filter(MenuList, menu => menu["mobile"])
    // },
    isProcessingTimelineActive() {
      if (!this.processing) return false
      return this.processing["cd_project"]
    },
    isOdm() {
      if (!this.processing) return false
      return this.processing["bl_use_odm"]
    }
  },
  beforeDestroy() {
    this.cleanMapView()
  }
}
</script>

<style scoped lang="scss">
@import "~leaflet/dist/leaflet.css";
@import "~leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.css";
@import "~leaflet-draw/dist/leaflet.draw.css";
@import "../sass/mixins";
@import "../sass/leaflet";

::v-deep .v-application--wrap {
  overflow: hidden;
}

.content {
  z-index: 1;
}

.content-tools {
  position: absolute;
  z-index: 2;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  -webkit-transition-property: padding-left, -webkit-transform;
  transition-property: transform, padding-left, -webkit-transform;

  &.active {
    padding-left: 350px;

    @include display-sm-and-down {
      padding-left: 100%;
    }
  }

  &.full-height {
    height: 100%;
  }

  &.full-width {
    width: 100%;
  }

  .content-tools__item {
    position: absolute;
  }

  .processing-timeline__wrapper {
    position: relative;

    @include display-sm-and-down {
      justify-content: flex-end;
    }
  }

  .toolbox {
    display: flex;
    flex: 0 1 0;
    width: auto;
  }

  .btn-drawer__handler {
    top: 50%;
  }

  .map__type {
    position: absolute;
  }
}

.tools {
  left: 0;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  -webkit-transition-property: padding-left, -webkit-transform;
  transition-property: transform, padding-left, -webkit-transform;
  height: 100%;
  position: absolute;
  z-index: 2;

  .btn-drawer__handler {
    top: 50%;
  }

  .map__type {
    position: absolute;
  }

  &.active {
    padding-left: 350px;

    @include display-sm-and-down {
      padding-left: 100%;
    }
  }
}

.right {
  right: 0;
}

.left {
  left: 0;
}

.bottom {
  bottom: 0;
}

.top {
  top: 0;
}
</style>
